function StatCard({ icon, value, label }) {
  return (
    <div className="flex flex-col items-center gap-1 py-3 flex-1">
      <div className="w-10 h-10 flex items-center justify-center text-xl">
        {icon}
      </div>
      <div className="text-xl font-bold text-gray-800">{value}</div>
      <div className="text-xs text-gray-500 text-center">{label}</div>
    </div>
  );
}

function WeeklyStats({ overview, streakDays }) {
  if (!overview) {
    return null;
  }

  const streak = streakDays ?? 0;
  const videosWatched = overview.videos_completed_last_7_days ?? 0;
  const qaSessions = overview.qa_sessions_last_7_days ?? 0;
  const avgScore = overview.avg_chat_score ?? 0;

  const tiles = [
    streak > 0 && {
      key: "streak",
      icon: "🔥",
      value: streak,
      label: "day streak",
    },
    videosWatched > 0 && {
      key: "videos",
      icon: "📺",
      value: videosWatched,
      label: "videos watched",
    },
    qaSessions > 0 && {
      key: "qa",
      icon: "💬",
      value: qaSessions,
      label: "Q&A sessions",
    },
    avgScore > 0 && {
      key: "score",
      icon: "⭐",
      value: Number(avgScore).toFixed(1),
      label: "avg score",
    },
  ].filter(Boolean);

  if (tiles.length === 0) {
    return null;
  }

  return (
    <div className="bg-white rounded-2xl border border-gray-200 shadow-sm p-4">
      <h4 className="text-lg font-bold text-gray-800 mb-3">This Week</h4>
      <div className="grid grid-cols-4 md:grid-cols-2 gap-y-2">
        {tiles.map((tile) => (
          <StatCard
            key={tile.key}
            icon={tile.icon}
            value={tile.value}
            label={tile.label}
          />
        ))}
      </div>
    </div>
  );
}

export default WeeklyStats;
